import React from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import serviciohttp from '../servicios/ServicioHttp';
import servicioformatos from '../servicios/ServicioFormatos';



export class AdministracionTicket extends React.Component {
    constructor() {
        super();
        this.state = {
            ticket: {},
            paginacion: { registrosPorPagina: 5,join:{"ttCfdi":"alias_ttCfdi"}},
            inicio: 0,
            errores: {},
            modalConfirmacion:false,
            codigo:"",
            ticketEliminar:{}
        }

    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    obtenerResultados = () => {
        const { paginacion } = this.state;
        serviciohttp.consumirPostHttp("administracion_ticket/consulta_estado.json",paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        });
    }

    buscar_ticket=()=>{
        let { ticket, paginacion } = this.state;
        let erorres = this.validar_formulario(ticket);
        this.setState({ errores: erorres });
        if (servicioAsignacionValoresObjetos.esObjetoVacio(erorres)) {
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"codigo",
                valorPropiedad:ticket.codigo}];
           this.obtenerResultados();
        }

       

    }

    validar_formulario=(ticket)=>{
        let error={};
        if(!ticket.codigo)
        error.codigo="campo requerido"
        return error;
    }


    template_eliminar_ticket=(rowData, column)=>{
        if(rowData[4]===0)
        return <div>
             <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
            tooltip="eliminar" onClick={(e) => this.pre_eliminar_ticket(column.rowData)} >
        </Button>
        </div>
    }

    pre_eliminar_ticket=(rowData)=>{
        this.setState({modalConfirmacion:true,codigo:rowData[2],ticketEliminar:{id:rowData[0]}})
    }

    columna_fechaticket=(rowData)=>{
        return servicioformatos.formatearFechaString(rowData[3])
    }

    columna_fechaFacturacion=(rowData)=>{
        return servicioformatos.formatearFechaString(rowData[5])
    }

    columna_fechaCaptura=(rowData)=>{
        return servicioformatos.formatearFechaString(rowData[6])
    }

    columna_estado=(rowData)=>{
        if(rowData[4]===0)
        return "CAPTURADO";
        if(rowData[4]===1)
        return "FACTURANDO";
        if(rowData[4]===2)
        return "FACTURADO";
        if(rowData[5]===3)
        return "CANCELADO";
    }

    cerrarModalConfirmacion=()=>{
        this.setState({modalConfirmacion:false,errores:{}});
    }

    eliminar_codigo=()=>{
        let{ticketEliminar}=this.state;
        serviciohttp.consumirPostHttp("/ticket/eliminar.json",ticketEliminar).then((response) => {
            this.obtenerResultados();
            this.cerrarModalConfirmacion();
        });
    }

    render() {
        let { ticket,paginacion,errores,codigo } = this.state;

        const dialogFooterConfirmacionEliminarCarril = (
            <div>
              <Button icon="pi-md-check" onClick={this.eliminar_codigo} label="Si estoy seguro" className="teal-btn flat-btn" />
              <Button icon="pi-md-close" onClick={this.cerrarModalConfirmacion} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
          );
        return (<div>
            <Growl ref={(el) => this.growl = el} />
            <div className="card card-w-title">
            <h1 style={{marginBottom:'50px'}}>Administración de Tickets</h1>
                <div className="p-grid p-fluid" style={{marginBottom:'10px', display:'flex', justifyContent:'space-around'}}>
                <div className="p-col-12 p-md-3" style={{display:'flex', justifyContent:'flex-end', alignItems:'center'}}>
                   <strong><label htmlFor="codigo">* Código 18 Caracteres:</label></strong>
                  </div>
                    <div className="p-col-5" style={{alignSelf:'center'}}>
                        <InputText name="ticket.codigo" value={ticket.codigo || ''} onChange={this.asignarValoresObjeto}
                            className={errores.codigo ? 'p-error' : ''} size="18" placeholder="Escribe el código"/>
                        {errores.codigo ? <div> <Message severity="error" text={errores.codigo} /> </div> : null}
                    </div>
                    <div className="p-col-3">
                        <Button  icon="pi-md-edit" className="teal-btn flat-btn" label="Buscar"
                            tooltip="Buscar" onClick={this.buscar_ticket} >
                        </Button>

                    </div>
                </div>
            </div>

            <DataTable value={paginacion.datos} responsive={true} header="MIS TICKETS" style={{marginTop:'30px', marginBottom:'50px'}}>
                <Column field="1" header="UUID" autoLayout={true} style={{textAlign:'center'}}/>
                <Column field="2" header="Código" style={{ width: '180px', textAlign:'center'}} autoLayout={true} />
                <Column body={this.columna_fechaticket} header="Fecha del Ticket" autoLayout={true} style={{textAlign:'center'}}/>
                <Column body={this.columna_estado} header="Estado" autoLayout={true} style={{textAlign:'center'}}/>
                <Column body={this.columna_fechaFacturacion} header="Fecha Facturación" autoLayout={true} style={{textAlign:'center'}}/>
                <Column body={this.columna_fechaCaptura}  header="Fecha Captura" autoLayout={true} style={{textAlign:'center'}}/>
                <Column body={this.template_eliminar_ticket} autoLayout={true} style={{textAlign:'center'}}/>
            </DataTable>


      <Dialog header="Confirmación" visible={this.state.modalConfirmacion} footer={dialogFooterConfirmacionEliminarCarril} onHide={this.cerrarModalConfirmacion}>
        <h2>¿Estás seguro de eliminar el ticket {codigo}?</h2>
      </Dialog>
        </div>)
    }


}